var app = angular.module("leonardo");

var ContactListController = function($scope, $state, ngDialog, $controller, ContactRestService, AuthDataService,
                                     FilterService, PermissionService) {

  $scope.permissionService = PermissionService;

  $scope.getEntitiesPromise = function(options) {
    options.account = FilterService.getFilter('account_reports');
    options.portfolio = FilterService.getFilter('portfolio_reports');
    options.property = FilterService.getFilter('property_reports');
    options.contact_type = FilterService.getFilter('contact_contact_type');
    options.name = FilterService.getFilter('contact_name');
    options.email = FilterService.getFilter('contact_email');
    options.title = FilterService.getFilter('contact_title');
    return ContactRestService.getlist(options);
  };

  $scope.showEditContact = function(contact){
    ngDialog.open({
      controller: 'ContactEditDialog',
      templateUrl: 'views/templates/dialog/contact/contact.html',
      data: {
        contact: contact
      }
    });
  };

  $scope.showDeleteContact = function (contact) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: contact,
        type: 'contact',
      }
    }).then(function(data){
      ContactRestService.updateCollection(data, true);
      $scope.loadPage($scope.page);
    });
  };

  $scope.$on('contact:changed', function () {
    $scope.loadPage(1);
  });

  $controller('TableFilterController', { $scope: $scope });

  if (AuthDataService.isNotStaff()) {
    $scope.loadPage(1);
  }
};

app.controller('ContactListController', ['$scope', '$state', 'ngDialog', '$controller', 'ContactRestService',
  'AuthDataService', 'FilterService', 'PermissionService', ContactListController]);
